import { AppProviderContext } from '@websrc/App/AppContext'
import { useContext } from 'react'

export const useStaticText = () => {
  const { staticText } = useContext(AppProviderContext)

  if (!staticText) {
    throw Error('Static text not found')
  }

  return staticText
}
